import { Link } from '../shared/Link';

export const enum CandidateReferenceCategoryType {
  news = 'news',
  'official-website' = 'official-website',
  other = 'other',
  questionnaire = 'questionnaire',
  social = 'social',
  website = 'website',
}

export interface CandidateReferenceCategory {
  type: CandidateReferenceCategoryType;
  sources: Link[];
  missing: boolean;
}

export interface References {
  checked: boolean;
  totalSources: number;
  categories: CandidateReferenceCategory[];
}